(function auditHistoryControllerDefinition() {
    'use strict';

    angular.module('Audit')
        .controller('AuditHistoryController', [
            '$scope', '$state', 'errorsExtend', 'authExtend', '$translate', 'auditService', '$stateParams', 'storageService',
            function auditHistoryController($scope, $state, errors, authExtend, $translate, auditService, $stateParams, storageService) {
                $translate($stateParams.entityName)
                    .then(function (text) {
                        $scope.title = {
                            type: text,
                            displayName: $stateParams.displayName
                        }
                    });


                $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.view = function (audit) {
                    $state.go('audit-detail', { id: audit.id });
                };

                $scope.fillAccordion = function () {
                    $scope.auditItems.forEach(function (audit) {
                        var accordionIsOpen = false;
                        Object.defineProperty(audit, "accordionIsOpen", {
                            get: function () { return accordionIsOpen; },
                            set: function (newValue) {

                                if (event.target.id !== "options" && !(event.target.offsetParent !== null && event.target.offsetParent.id === "options")) {

                                    if (event.target.offsetParent !== null && event.target.offsetParent.offsetParent.id === "p") {

                                        accordionIsOpen = newValue;
                                    }
                                }
                            }
                        });
                    });
                };

                $scope.cancel = function () {
                    $state.goBack();
                };

                $scope.cleanFilters = function () {

                    storageService.clearAuditFilter();
                    $scope.find = storageService.getAuditFilter();
                    $scope.find.actionType = undefined;
                    $scope.find.organizationalUnitId = authExtend.getOrganizationId(),
                        $scope.find.organizationalUnitName = authExtend.getOrganizationName(),
                        $scope.model = {
                            employeeFile: undefined,
                            employeeFileNumber: undefined
                        };

                    $scope.auditItems = [];
                    $scope.data.currentPage = 1,
                        $scope.data.totalItems = 0;
                    $scope.data.from = 0;
                };

                $scope.findAction = function () {
                    if ($scope.searchAudit != null) {
                        if (!$scope.searchAudit.$valid) {
                            $scope.searchAudit.$setSubmitted();
                            errors.showError('VerifyFormData');
                            return false;
                        }
                    }
                    storageService.setAuditFilter($scope.find);

                    return $scope.executeFind();
                }

                $scope.executeFind = function () {
                    var filters = $scope.createFilters();

                    return auditService.get(filters).then(function (result) {
                        $scope.auditItems = result.values;
                        $scope.data.totalItems = result.count;
                        $scope.data.from = 1 + ($scope.data.itemPerPage * ($scope.data.currentPage - 1));

                        if ($scope.auditItems.length == 0) {
                            $scope.find.showNoData = true;
                        }

                        if ($scope.auditItems.length > 0) {
                            $scope.accordionState.isOpen = false;
                            $scope.find.showResult = true;
                            $scope.fillAccordion();
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.createFilters = function () {
                    var idOu = $scope.find.organizationalUnit ? $scope.find.organizationalUnit.id : undefined;

                    var filters = {
                        organizationalUnitId: authExtend.getOrganizationId(),
                        itemPerPage: $scope.data.itemPerPage,
                        page: $scope.data.currentPage,
                        entityName: $stateParams.entityName,
                        entityId: $stateParams.entityValues
                    };

                    $scope.find.showNoData = false;

                    return filters;
                }

                $scope.load = function () {
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    };
                    $scope.cleanFilters();
                    $scope.emptyOu = true;

                    $scope.userId = authExtend.getUserId();

                    var filters = {
                        organizationalUnitId: $stateParams.organizationalUnitId || authExtend.getOrganizationId(),
                        itemPerPage: $scope.data.itemPerPage,
                        page: $scope.data.currentPage,
                        entityName: $stateParams.entityName,
                        entityId: $stateParams.entityValues
                    };

                    $scope.showNoData = false;

                    return auditService.get(filters).then(function (result) {
                        $scope.auditItems = result.values;
                        $scope.data.totalItems = result.count;
                        $scope.data.from = 1 + ($scope.data.itemPerPage * ($scope.data.currentPage - 1));

                        if ($scope.auditItems.length == 0) {
                            $scope.showNoData = true;
                        }

                        if ($scope.auditItems.length > 0) {
                            $scope.showResult = true;
                            $scope.fillAccordion();
                        }
                    }, function (error) {
                        errors.showError(error);
                    });

                };

                $scope.load();
            }]);
})();